/**
 * Deep-dive-step primitive, extracted from the original `DeepDiveStep` body's main section: the
 * `DeepDivePanel` (scenario-driven Assess/Act conversation guide) inside its `Block`. The step's
 * Comments section reuses the shared `comments` primitive, so it is not re-implemented here.
 *
 * Section title/lead come from the authored `config`, falling back to `sectionHeadings` (the same
 * source the body read); state/customer/author/presenting come from the shared `RunnerContext`. No
 * presentation is duplicated: this reuses the existing `Block`/`DeepDivePanel` leaves the body used.
 */
import { Block } from '../../components/ui/primitives';
import { asIconName } from '../../components/ui/Icon';
import { sectionHeadings } from '../../config/sectionHeadings';
import { DeepDivePanel } from '../../components/steps/DeepDivePanel';
import type { PrimitiveProps } from './registry';

export function DeepDivePanelBlock({ ctx, config }: PrimitiveProps): JSX.Element {
  const h = sectionHeadings('deepdive');
  return (
    <Block
      icon={asIconName(config?.icon, 'chat')}
      title={(config?.title as string) || h.main?.title || ''}
      lead={(config?.lead as string) || h.main?.lead}
    >
      <DeepDivePanel
        state={ctx.state}
        presenting={ctx.presenting}
        customerName={ctx.customerName}
        seName={ctx.author}
      />
    </Block>
  );
}
